import styled, { css } from "styled-components";
import {HomepageHeaderArenaIconDefaultBox} from "./home-page-header-arena-icon.default.box";

export const HomepageHeaderArenaIconSIBox = styled(HomepageHeaderArenaIconDefaultBox)`
  ${props => props.useSmallHeaderArenas ? css`max-width: 252px` : ""};
  margin-right: 1rem;
  margin-left: 1rem;
  &::after {
    display: none;
  }

  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    ${props => props.useSmallHeaderArenas ? css`max-width: 210px` : ""};
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    ${props => props.useSmallHeaderArenas ? css`min-width: 100px;`: ""};
  }

`;
